<template>
  <div>
    <h2>{{service.name}}</h2>
    <hr>

    <div class="row">

      <div class="p-3">
        <ServiceServer :server-id="service.serverId" :key="service.serverId"/>

        <ServiceDomains v-if="service.id" :service-id="service.id" :key="service.id"/>

        <ServiceSettings v-if="service.id" :service-id="service.id" :key="service.id"/>

        <ServiceBackup v-if="service.serverId" :service-id="service.id" :key="service.id"/>

      </div>

    </div>


  </div>
</template>

<script setup>
import {defineProps, computed} from 'vue'

const props  = defineProps({
  id: Number,
})


import {useServiceStore} from "@/store/services";
import ServiceBackup from "@/views/services/ServiceBackup";
import ServiceDomains from "@/views/services/ServiceDomains";
import ServiceServer from "@/views/services/ServiceServer";
import ServiceSettings from "@/views/services/ServiceSettings.vue";
const serviceStore = useServiceStore()
const service = computed(() => serviceStore.item)
serviceStore.getById(props.id)


</script>
